<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="saveData()">
                {{form.id == '' ? '下一步' : '保 存'}}

            </el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="160px">
          <el-form-item label="触点名称" prop="contactName">
            <el-input v-model="form.contactName" placeholder="触点名称" :disabled="this.isEdit" ></el-input>
            <span style="color: red">尽量描述清楚本次触点的用途</span>
          </el-form-item>

            <el-form-item label="触点标签" prop="contactTag" >
                <el-select v-model="form.contactTag"  filterable
                           clearable
                           allow-create placeholder="触点标签">
                    <el-option
                            v-for="item in contactTags"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="落地页" prop="contactPage"  >
            <el-input v-model="form.contactPage" placeholder="落地页" :disabled="this.isEdit"></el-input>
          </el-form-item>
          <el-form-item label="发送类型" prop="sendTypeId" >
            <el-select v-model="form.sendTypeId"   placeholder="发送类型">
              <el-option
                  v-for="item in sendTypeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


        </el-form>
    </div>


</template>
<script>
    //导入 HTTP请求方法
    import {
      saveContact,
      getContactEntity,getContactTags
    } from '../../api/api';

    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        components: {ElDialog}, data() {

            return {
                rules: {
                  contactName: [
                    {required: true, message: '请输入触点名称', trigger: 'blur'},
                    {min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'}
                  ],
                  contactTag: [
                    {required: true, message: '请输入触点标签', trigger: 'blur'},
                    {min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'}
                  ],
                  contactPage: [
                    {required: true, message: '请输入落地页名称', trigger: 'blur'},
                    {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur'}
                  ],

                  sendTypeId: [
                    {required: true, message: '请输入发送类型', trigger: 'blur'},

                  ],
                },
                form: {
                    id:this.$route.query.id,
                    contactName:'',
                    contactTag:'',
                    contactPage:'',
                    sendTypeId:'',
                    sendType:'',
                },
              sendTypeData:[{id:1,name:"短信"},{id:2,name:"模板消息"},{id:3,name:"客服消息"},{id:4,name:"推文"},{id:5,name:"其他"}],
              contactTags:[],
              isEdit:false,
            };

        },
        //props:['activeParam'],
        //挂载时候执行
        mounted(){
          getContactTags({}).then(res => {
            this.contactTags = res.data.value;
            this.getEntity();
          });



        },
        computed: {},
        methods: {
          getSendTypeName( cellValue) {
            for(var key in this.sendTypeData){
              if(this.sendTypeData[key].id==cellValue) {
                return this.sendTypeData[key].name;
              }
            }
            //return this.randData.name;

          },
            getEntity(){
                if(this.form.id!=''&&this.form.id!=null) {
                  this.isEdit=true;
                    console.log("id:"+this.form.id);
                  getContactEntity({id: this.form.id}).then(res => {
                        this.form = res.data.value;
                    });
                }
            },
            saveData(){
                this.$refs.form.validate((valid)=>{
                   if(valid){
                       this.loading = true;
                       console.log(this.form)
                     this.form.sendType=this.getSendTypeName(this.form.sendTypeId);
                     saveContact(this.form).then((res) => {
                           this.loading = false;
                           if (res.data.status == 200) {
                               this.showDialog = false;
                               this.$message({
                                   message: '保存成功',
                                   type: 'success'
                               });

                               if (this.form.id == ''||this.form.id==null) {
                                   this.form = res.data.value;
                                  //editeActive(this.form);
                               }
                             this.$router.push({
                               path: 'contactList',
                               name: 'contactList',
                               query: {

                               }
                             })

                           } else {
                               this.$message({
                                   showClose: true,
                                   message: res.data.message,
                                   type: 'error'
                               });
                           }
                       });
                   }else{
                        //验证不通过
                   }
                });

            },


        }
    }
</script>


// WEBPACK FOOTER //
// src/views/contact/contactEdit.vue